export default class TexturedPanel extends Phaser.Group {
  constructor(game, { width = 960, height = 480, corner = 30, shadow = true }) {
    super(game);

    this.panelWidth = width;
    this.panelHeight = height;

    this.setSize({ width, height, corner, shadow });
  }

  get width() {
    return this.panelWidth;
  }
  get height() {
    return this.panelHeight;
  }

  setSize({ width = 960, height = 480, corner = 30, shadow = true }) {
    this.panelWidth = width;
    this.panelHeight = height;

    if (!this.panel) {
      this.panel = this.game.make.graphics();
      this.panelTexture = this.game.make.image(0, 0, 'winkled_texture');
      this.panelMask = this.game.make.graphics();
      this.panelTexture.mask = this.panelMask;
      this.add(this.panel);
      this.add(this.panelTexture);
      // this.panelTexture.tint = 0xffff00;
      this.add(this.panelMask);
    } else {
      this.panel.clear();
      this.panelMask.clear();
    }

    if (shadow) {
      this.panel.beginFill(0x000000, 0.25);
      this.panel.drawRoundedRect(0, 5, width, height, corner);
    }

    this.panel.beginFill(0xffffff);
    this.panel.drawRoundedRect(0, 0, width, height, corner);

    this.panelMask.beginFill(0xffffff);
    this.panelMask.drawRoundedRect(0, 0, width, height, corner);

    this.panelTexture.scale.set(
      Math.min(1, Math.max(this.panelTexture.width / width, this.panelTexture.height / height))
    );
    this.panelTexture.x = -Math.random() * (this.panelTexture.width - width);
    this.panelTexture.y = -Math.random() * (this.panelTexture.height - height);
  }

  shutDown() {
    this.panel.destroy(true);
    this.panelMask.destroy(true);
    this.panelTexture.destroy(true);
    this.panel = null;
    this.panelMask = null;
    this.panelTexture = null;
    super.destroy(true);
  }
}



// WEBPACK FOOTER //
// ./js/app/display/ui/TexturedPanel.js